import { Z_TUTORIAL } from './TutorialContext';

/** Folga entre a borda do alvo e a borda do recorte. */
const FOLGA = 8;
const RAIO = 10;
/** Folga do recorte até a borda da janela. */
const MARGEM_DA_JANELA = 4;

/**
 * O recorte cabe na janela: alvo maior que a tela virava um recorte com a
 * borda fora da vista, sem o contorno que diz onde ele está.
 */
const recorteNaJanela = (rect) => {
  const topo = Math.max(MARGEM_DA_JANELA, rect.top - FOLGA);
  const esquerda = Math.max(MARGEM_DA_JANELA, rect.left - FOLGA);
  const base = Math.min(window.innerHeight - MARGEM_DA_JANELA, rect.top + rect.height + FOLGA);
  const direita = Math.min(window.innerWidth - MARGEM_DA_JANELA, rect.left + rect.width + FOLGA);
  return {
    top: topo,
    left: esquerda,
    width: Math.max(0, direita - esquerda),
    height: Math.max(0, base - topo),
  };
};

/**
 * Escurece a tela, abre um recorte sobre o alvo e bloqueia o clique fora dele.
 *
 * Duas camadas de propósito: a luz é só visual (`pointer-events: none`, uma
 * div com box-shadow gigante, que anima igual em todo navegador) e o bloqueio
 * é feito por quatro divs em volta do recorte. O que está sob elas não recebe
 * clique; o que está no recorte recebe.
 *
 * Passo que só MOSTRA ganha uma tampa sobre o recorte, que leva ao próximo
 * passo: o clique distraído no botão destacado (Salvar, Confirmar
 * Movimentação) não chega ao botão.
 */
const Escurecido = ({ rect, animar = false, aoClicarNoRecorte }) => {
  const recorte = rect ? recorteNaJanela(rect) : null;
  // Sem alvo, a mesma peça escurece a tela inteira: um recorte de tamanho zero
  // no centro. Trocar de peça refazia o fade de entrada a cada passo sem alvo.
  const luz = recorte ?? {
    top: window.innerHeight / 2,
    left: window.innerWidth / 2,
    width: 0,
    height: 0,
  };

  return (
    <>
      <div
        aria-hidden="true"
        data-testid="tutorial-escurecido"
        className={[
          'tutorial-luz tutorial-entra fixed pointer-events-none',
          recorte ? '' : 'tutorial-luz--sem-alvo',
          animar ? 'tutorial-desliza' : '',
        ].join(' ')}
        style={{ ...luz, borderRadius: RAIO, zIndex: Z_TUTORIAL }}
      />

      {recorte ? (
        <>
          <Bloqueio top={0} left={0} width="100%" height={Math.max(0, recorte.top)} />
          <Bloqueio
            top={recorte.top + recorte.height}
            left={0}
            width="100%"
            height={`calc(100% - ${recorte.top + recorte.height}px)`}
          />
          <Bloqueio top={recorte.top} left={0} width={Math.max(0, recorte.left)} height={recorte.height} />
          <Bloqueio
            top={recorte.top}
            left={recorte.left + recorte.width}
            width={`calc(100% - ${recorte.left + recorte.width}px)`}
            height={recorte.height}
          />
          {aoClicarNoRecorte && (
            <div
              aria-hidden="true"
              data-testid="tutorial-tampa"
              className="fixed cursor-pointer"
              onClick={aoClicarNoRecorte}
              style={{ ...recorte, zIndex: Z_TUTORIAL }}
            />
          )}
        </>
      ) : (
        <Bloqueio top={0} left={0} width="100%" height="100%" />
      )}
    </>
  );
};

const Bloqueio = ({ top, left, width, height }) => (
  <div aria-hidden="true" className="fixed" style={{ top, left, width, height, zIndex: Z_TUTORIAL }} />
);

export default Escurecido;
